// api.js
import axios from "axios";
import store from "./index.js";
import moment from "moment";

// create an axios instance with default options
const els_url = window.funnel_data.els_url;
const http = axios.create({ baseURL: els_url });

export default {
  getFlux() {
    const finalQuery = this.createQuery();

    return http
      .get(els_url + "/_search", {
        params: {
          source: JSON.stringify(finalQuery),
          source_content_type: "application/json",
        },
      })
      .then((res) => {
        return res;
      });
  },

  createQuery() {
    let must = [
      {
        match_phrase: {
          CODE_TOUR: store.state.voyage.code_resa,
        },
      },
      {
        match_phrase: {
          CODE_AEROPORT_DEPART: store.state.selectedAeroport,
        },
      },
    ];

    if (store.state.voyage.template == 3) {
      must.push({
        match: {
          NB_NUITS: store.state.selectedDuree,
        },
      });
    }

    let filter = [
      {
        range: {
          DATE_DEPART: {
            gte: moment().format("YYYY-MM-DD"),
            lte: moment()
              .add(18, "M")
              .format("YYYY-MM-DD"),
          },
        },
      },
    ];

    const new_query = {
      size: 10000,
      query: {
        bool: {
          must: must,
          filter: filter,
        },
      },
    };

    return new_query;
  },

  getDurees() {
    const new_query = {
      size: 0,
      query: {
        bool: {
          must: [
            {
              match_phrase: {
                CODE_TOUR: store.state.voyage.code_resa,
              },
            },
            {
              match_phrase: {
                CODE_AEROPORT_DEPART: store.state.selectedAeroport,
              },
            },
          ],
        },
      },
      aggs: {
        durees: {
          terms: {
            field: "NB_NUITS",
            size: 500,
          },
        },
      },
    };

    return http
      .get(els_url + "/_search", {
        params: {
          source: JSON.stringify(new_query),
          source_content_type: "application/json",
        },
      })
      .then((res) => {
        return res;
      });
  },

  getAeroports() {
    const new_query = {
      size: 0,
      query: {
        bool: {
          must: [
            {
              match_phrase: {
                CODE_TOUR: store.state.voyage.code_resa,
              },
            },
          ],
        },
      },
      aggs: {
        aeroports: {
          terms: {
            field: "CODE_AEROPORT_DEPART.keyword",
            size: 500,
          },
        },
      },
    };

    return http
      .get(els_url + "/_search", {
        params: {
          source: JSON.stringify(new_query),
          source_content_type: "application/json",
        },
      })
      .then((res) => {
        return res;
      });
  },
};
